import { FontAwesome5 } from "@expo/vector-icons"
import { theme } from "@common/theme/theme"
import React, { useEffect, useState } from "react"
import { TouchableOpacity } from "react-native"
import { useSafeAreaInsets } from "react-native-safe-area-context"

/**
 * Discreet close affordance for the auto-mode overlays. Hidden for the first
 * `delayMs` so the student engages with the flow before bailing out, then
 * appears as a top-left "✕". Replaces the easy-to-miss bottom "Fermer" link.
 *
 * The reveal timer is keyed on `visible`: it resets whenever the overlay
 * re-opens. `disabled` hides the button without resetting the timer (used while
 * a choice is committing).
 */
const AutoModeCloseButton = ({ visible, onPress, disabled = false, delayMs = 30000 }) => {
    const insets = useSafeAreaInsets()
    const [shown, setShown] = useState(false)

    useEffect(() => {
        if (!visible) {
            setShown(false)
            return
        }
        const timer = setTimeout(() => setShown(true), delayMs)
        return () => clearTimeout(timer)
    }, [visible, delayMs])

    if (!visible || !shown || disabled) return null

    return (
        <TouchableOpacity
            onPress={onPress}
            hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
            style={{
                position: "absolute",
                top: insets.top + 8,
                left: 16,
                zIndex: 101,
                elevation: 101,
                width: 36,
                height: 36,
                borderRadius: 18,
                backgroundColor: theme.colors.white,
                alignItems: "center",
                justifyContent: "center",
                shadowColor: theme.colors.grey,
                shadowOffset: { width: 0, height: 2 },
                shadowOpacity: 0.15,
                shadowRadius: 4,
            }}
        >
            <FontAwesome5 name="times" size={18} color={theme.colors.grey} />
        </TouchableOpacity>
    )
}

export default AutoModeCloseButton
